import * as THREE from 'three';

function createSkiGeometry(): THREE.BufferGeometry {
  // Four vertices per station form one continuous, gently upturned plank.
  // Keeping the top, base, and edges in the same mesh avoids the seams that
  // made the old stacked-box ski look like several overlapping parts.
  const stations = [
    { z: -0.76, y: 0.085, halfWidth: 0.034 },
    { z: -0.68, y: 0.046, halfWidth: 0.053 },
    { z: -0.52, y: 0.006, halfWidth: 0.06 },
    { z: -0.04, y: 0, halfWidth: 0.047 },
    { z: 0.45, y: 0, halfWidth: 0.06 },
    { z: 0.56, y: 0.008, halfWidth: 0.045 },
  ] as const;
  const thickness = 0.028;
  const positions: number[] = [];
  const indices: number[] = [];

  for (const station of stations) {
    const top = station.y + thickness * 0.5;
    const bottom = station.y - thickness * 0.5;
    positions.push(
      -station.halfWidth, top, station.z,
      station.halfWidth, top, station.z,
      station.halfWidth, bottom, station.z,
      -station.halfWidth, bottom, station.z,
    );
  }

  for (let station = 0; station < stations.length - 1; station += 1) {
    const current = station * 4;
    const next = current + 4;
    indices.push(
      current, next, next + 1, current, next + 1, current + 1,
      current + 1, next + 1, next + 2, current + 1, next + 2, current + 2,
      current + 2, next + 2, next + 3, current + 2, next + 3, current + 3,
      current + 3, next + 3, next, current + 3, next, current,
    );
  }

  const last = (stations.length - 1) * 4;
  indices.push(0, 1, 2, 0, 2, 3, last, last + 3, last + 2, last, last + 2, last + 1);

  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
  geometry.setIndex(indices);
  geometry.computeVertexNormals();
  geometry.computeBoundingBox();
  geometry.computeBoundingSphere();
  return geometry;
}

export function createSkiRig(): THREE.Group {
  const rig = new THREE.Group();
  rig.position.set(0, -0.82, -1.16);
  rig.scale.setScalar(0.78);

  const skiMaterial = new THREE.MeshStandardMaterial({
    color: 0xe97968,
    roughness: 0.72,
    metalness: 0.02,
    flatShading: true,
  });
  const skiGeometry = createSkiGeometry();

  for (const side of [-1, 1]) {
    const ski = new THREE.Group();
    ski.position.x = side * 0.145;

    const plank = new THREE.Mesh(skiGeometry, skiMaterial);
    ski.add(plank);
    rig.add(ski);
  }

  return rig;
}

export function setSkiRigSteering(rig: THREE.Group, steering: number): void {
  rig.rotation.z = steering * 0.055;
  const carveAngle = -steering * 0.14;
  for (const ski of rig.children) ski.rotation.y = carveAngle;
}
